export var FASLET_ACTION_TYPE;
(function (FASLET_ACTION_TYPE) {
    FASLET_ACTION_TYPE["afterClose"] = "after-close";
    FASLET_ACTION_TYPE["preCalculated"] = "pre-calculated";
    FASLET_ACTION_TYPE["newRequest"] = "new-request";
})(FASLET_ACTION_TYPE || (FASLET_ACTION_TYPE = {}));
